<template>
  <section ref="pc_common" :class="`detail detect_deviece_${deviceType} state_${deviceType}`">
    <HeadBar :title="domainConfig['IAmTitle']" :logo="domainConfig['icon']"
      :deviceType="deviceType" />
    <section v-if="pagenum == 0 && novalInfo" class="page-0 pc_padding">
      <!-- <div v-if="deviceType != 'mobile'" class="book-reading-nav pc_padding">
        <div class="book-reading-nav-item contents cursor" @click="toggleContents">
          Contents
          <img src="@/assets/up.png" :class="{'flip':showContents}" alt="">
        </div>
        <div class="book-reading-nav-item goback cursor" @click="gohome()">
          <img src="@/assets/conents-icon.png" alt="">
          Go to Books
        </div>
      </div> -->
      <div class="detail-recommand-banner-row" @click="fullpageclick(1)">
        <div class="detail-recommand-banner-shadow" />
        <img v-lazy="novalInfo.bigImg" class="detail-recommand-banner-img" alt="">
        <div class="recomannd-banner-rate-info-row">
          <div class="recomannd-banner-rate-info-tag">
            <div class="recomannd-banner-rate-info-tag-item" v-html="novalInfo.novelType" />
          </div>
          <div class="recomannd-banner-rate-info-stars-row">
            <img src="@/assets/star.png" alt=""> {{ novalInfo.novelScore }}/10
          </div>
        </div>
      </div>
      <div class="detail-recommand-title" @click="fullpageclick(1)">
        {{ novalInfo.novelName }}
      </div>
      <AdComponent ref="ads-cover-1" class="content pc_padding" :ads="adsensConfig?.cover_1"
        :showDebug="showDebug" />
      <div class="detail-recommand-author" @click="fullpageclick(1)">
        {{ novalInfo.novelAuthorName }}
      </div>
      <div class="detail-recommand-content" @click="fullpageclick(1)"
        v-html="novalInfo.novelStoryIntro" />
      <div class="detail-recommand-btn cursor" @click="gochapter(1)">
        Read Now
      </div>

      <!-- <AdComponent ref="ads-cover-2" class="content pc_padding" :ads="adsensConfig?.cover_2"
        :showDebug="showDebug" /> -->

      <div v-if="hasNext" class="nxt-page-btn cursor" @click="gochapter(1)">
        Next Page <img class="arrow" src="@/assets/arror.png" alt="">
      </div>
    </section>
    <section v-if="pagenum != 0 && novalInfo" class="page-n pc_padding">
      <div v-if="deviceType=='mobile' && pagenum!=0" class="page-section prev-page cursor"
        @click="gochapter(parseInt(pagenum)-1)" />
      <div v-if="deviceType=='mobile' && hasNext" class="page-section next-page cursor"
        @click="gochapter(parseInt(pagenum)+1)" />
      <div class="book-reading-nav">
        <div class="book-reading-nav-item contents cursor" @click="toggleContents">
          Contents
          <img src="@/assets/up.png" :class="{'flip':showContents}" alt="">
        </div>
        <div class="book-reading-nav-item goback cursor" @click="gohome()">
          <img src="@/assets/conents-icon.png" alt="">
          Go to Books
        </div>
      </div>

      <div class="book-reading-content-container">
        <div v-show="showContents" class="contents-menu">
          <ul>
            <li v-for="(item, index) in novalInfo.novelChapter" :key="index" class="cursor"
              :class="{'active':pagenum == index}" @click="gochapter(index)">
              {{ item }}
            </li>
          </ul>
        </div>
        <div v-if="novalDetail && novalDetail.length>0" class="book-reading-content-txt-container">
          <div class="book-reading-content-row">
            <div class="chapter-name" v-html="novalDetail[0].chapterName" />
            <AdComponent ref="ads-content-1" class="content " :ads="adsensConfig?.content_1"
              :showDebug="showDebug" />
            <div v-for="(data,i) in formattedContent" :key="`novel_${i}`" class="chapter-content"
              v-html="data.content" />
            <AdComponent ref="ads-content-2" class="content " :ads="adsensConfig?.content_2"
              :showDebug="showDebug" />
          </div>

          <div v-if="deviceType!='mobile'" class="pagenation-row">
            <div v-if="pagenum!=0" class="page-fixed prev-page cursor"
              @click="gochapter(parseInt(pagenum)-1)">
              <img src="@/assets/page-arr.png" alt=""> Prev
            </div>
            <div v-if="hasNext" class="page-fixed next-page cursor"
              @click="gochapter(parseInt(pagenum)+1)">
              <img src="@/assets/page-arr.png" alt=""> Next
            </div>
          </div>
        </div>
      </div>

      <!-- 背景遮挡层 -->
      <div v-if="showContents && deviceType=='mobile'" class="overlay" @click="toggleContents" />
    </section>
    <FootBar v-if="pagenum != 0 && deviceType=='mobile'" :deviceType="deviceType" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'
import HeadBar from '@/pages/components/head.vue';
import FootBar from '@/pages/components/footer.vue';
import '@/css/common.scss';
import '@/css/detail.scss'

export default {
  name: 'Detail',
  components: {
    AdComponent,
    HeadBar,
    FootBar
  },
  data () {
    return {
      pagenum: null,
      bookname: null,
      bookid: null,
      showContents: false,
      novalDetail: null,
      novalInfo: null,
      hasNext: false,
    };
  },
  metaInfo () {
    return {
      title: this.novalInfo?.novelName ? `${this.novalInfo.novelName} | ${this.domainConfig["IAmURL"]}` : `${this.domainConfig["IAmURL"]}`,
      meta: [
        {
          name: 'description',
          content: this.novalInfo?.novelStoryIntro ? this.novalInfo.novelStoryIntro : '',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'showDebug',
      'deviceType',
      'host',
      "adsensConfig",
      'adPosConfig',
      "domainConfig"
    ]),
    formattedContent () {
      return this.novalDetail.map(chapter => ({
        ...chapter,
        content: chapter.content.replace(/\n/g, '<br>')  // 替换换行符为 <br> 标签
      }));
    }
  },
  created () {
    const { bookname, pagenum, id } = this.$route.params
    console.log(bookname, pagenum, id);
    this.pagenum = pagenum
    this.bookname = bookname
    this.bookid = id

  },
  async activated () {
    console.log(`${this.$options.name} Component activated-----------`);
  },
  async mounted () {
    console.log(`-------------------${this.$options.name} mounted`)
    await this.getDetail(this.pagenum)
    this.loadAdSenseScript();  // 重新加载广告脚本
    this.watchForIframeInsertion()

    // 使用防抖包装滚动事件
    this.onScroll = this.debounce(this.onScroll.bind(this), 300);
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll);

    // 设置插屏广告定时器
    this.setupInterstitialAdTimer();

    // 在页面ready后执行showPos方法
    this.$nextTick(() => {
      setTimeout(() => {
        this.showPos();
      }, 1000); // 延迟1秒执行，确保页面元素已完全加载
    });
  },
  deactivated () {
    console.log(`${this.$options.name} Component deactivated-----------`);
  },
  beforeDestroy () {
    console.log(`-------------------${this.$options.name} beforeDestroy`);
    // 组件销毁时移除滚动事件监听
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    fullpageclick () {
      if (this.deviceType == 'mobile') {
        this.gochapter(1)
      }
    },
    gohome () {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/library${fullQueryString}`
    },
    toggleContents () {
      this.showContents = !this.showContents;
    },
    gochapter (page) {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      console.log(page);
      if (this.pagenum == page) return
      this.pagenum = page
      window.location.href = `${channel}/${this.bookname}/${this.bookid}/${page}${fullQueryString}`
    },
    //shuju
    async getDetail (page) {
      try {
        const res = await this.$global.server.getDetail({
          summaryId: parseInt(this.bookid),
          chapterNum: parseInt(page)
        })
        console.log(res)
        this.novalDetail = res.data.chapterList
        this.novalInfo = res.data.summaryInfo
        this.hasNext = res.data.hasNext
      } catch (err) {
        console.log(err)
      }
    },
    async getTagList () {
      try {
        const res = await this.$global.server.getTagList({ type: '3D' })
        console.log(res)
        this.tagList = res.data
      } catch (err) {
        console.log(err)
      }
    },
    async getImages () {
      try {
        const params = {
          pageNum: this.page,
          pageSize: 30,
          type: '3D'
        };

        // 只有当 this.tag 不为 null 时，才添加 tag 字段
        if (this.activeTag !== null) {
          params.tag = this.activeTag;
        }

        const res = await this.$global.server.getImages(params);
        console.log(res)
        console.log('iiiiiiiiii');
        if (res.code == 200) {
          let data = res.data.photos
          this.images.push(...data)
          this.hasNext = res.data.hasNext
          this.page++;
        }
      } catch (err) {
        console.log(err)
      }
    },
    seclecTag (tag) {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/tag/${tag}${fullQueryString}`
    },
    choosePic (id) {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/${id}${fullQueryString}`
    },
    //pubu
    loadItems () {
      if (this.isLoading) return; // 如果已经在加载，则不重复加载
      this.isLoading = true; // 设置加载状态

      // 模拟异步加载
      setTimeout(() => {
        const newItems = Array.from({ length: 20 }, (_, i) => ({
          src: `https://via.placeholder.com/${i + 1}00x${i + 2}00?text=Item+${i + 1 + this.page * 10}`,
          alt: `Item ${i + 1 + this.page * 10}`,
        }));
        this.items.push(...newItems);
        this.page++;
        this.isLoading = false; // 加载完成后重置加载状态
      }, 500);
    },
    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    onScroll () {
      // 获取文档的总高度
      const documentHeight = document.documentElement.scrollHeight;
      // 当前滚动的高度
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // 视口的高度
      const windowHeight = window.innerHeight;

      // 在滚动时执行 showPos 方法，获取当前可视范围内的广告坐标
      this.showPos();

      // 当滚动距离接近底部2000px时触发
      if (scrollTop + windowHeight >= documentHeight - 2000) {
        console.log('加载');
        // this.getImages();
      }
    },
    //广告相关start
    shouldInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.home.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    shouldDetailInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.detail.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    async loadAdSenseScript () {
      // 其他需要在初次加载时执行的操作
      // 先检查广告是否已经加载
      if (window.adsbygoogle && window.adsbygoogle.loaded) { // 检查广告是否已经加载
        console.log("Adsense script already loaded.");
        this.$eventrack('adscript_loaded', 'expose');
        this.observeAds()
        return; // 如果已加载，直接返回
      }
      await this.loadScriptConditionally();
    },
    watchForIframeInsertion () {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.tagName === 'IFRAME' && node.closest('ins.adsbygoogle')) {
              this.setupIframeTracking(); // 在检测到广告 iframe 插入后，调用 setupIframeTracking
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    },
    setupIframeTracking () {
      // let _this = this;
      console.log('ready to track iframe');
      const iframes = document.querySelectorAll('iframe');
      const tracker = new this.IframeTracker(this);
      iframes.forEach((iframe) => {
        tracker.addIframe(iframe, (iframeElement) => {
          console.log('Iframe 点击触发了!', iframeElement);
          const adContainer = iframeElement.closest('ins.adsbygoogle');

          if (adContainer) {
            // 获取父级 ins 元素的边界矩形
            const insRect = adContainer.getBoundingClientRect();

            // 计算父级 ins 元素相对于页面左上角的位置和高度
            const insX = insRect.left;
            const insY = insRect.top;
            const insHeight = insRect.height;

            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            let transformData = {
              insX: insX,
              insY: insY,
              insHeight: insHeight,
              windowWidth: windowWidth,
              windowHeight: windowHeight,
            }
            this.$adClick(JSON.stringify(transformData))
            tracker.trackEvent('ad_iframe_click', 'click', {
              'data-ad-slot': adContainer.dataset.adSlot,
            });
            this.ttTrack(adContainer.dataset.adSlot, 'click', 'ad_iframe_click');
          }
        });
      });
    },
    ttTrack (id, type = 'expose', name = 'ad') {
      console.log('track');
      const eventName = this.$store.state.hostInject?.ttEvent || 'ClickButton';
      if (eventName) {
        ttq.track(eventName);
      } else {
        ttq.track('ClickButton');
      }
    },
    IframeTracker: class {
      constructor(vues, resolution = 200) {
        this.vues = vues; // 保存 Vue 实例
        this.resolution = resolution;
        this.iframes = [];
        this.interval = null;
        this.activeIframe = null; // 存储最近被点击的iframe
        this.setupVisibilityTracking();
      }

      addIframe (element, callback) {
        const adContainer = element.closest('ins.adsbygoogle');
        const iframe = {
          element: element,
          callback: callback,
          hasTracked: false,
          adSlot: adContainer ? adContainer.dataset.adSlot : null,
        };
        this.iframes.push(iframe);

        if (!this.interval) {
          this.interval = setInterval(() => this.checkClick(), this.resolution);
        }
      }

      checkClick () {
        const activeElement = document.activeElement;
        if (activeElement) {
          this.iframes.forEach((iframe) => {
            if (activeElement === iframe.element && !iframe.hasTracked) {
              iframe.callback(iframe.element);
              iframe.hasTracked = true;
              this.activeIframe = iframe; // 更新最近被点击的iframe

              // 在iframe点击后也触发showPos方法上报广告位置
              this.vues.showPos();
            }
          });
        }
      }

      setupVisibilityTracking () {
        const hiddenProperty =
          'hidden' in document ? 'hidden' : 'webkitHidden' in document ? 'webkitHidden' : 'mozHidden' in document ? 'mozHidden' : null;
        const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');

        const onVisibilityChange = () => {
          if (!document[hiddenProperty]) {
            console.log('页面激活状态,返回页面?');
            this.activeIframe = null; // 重置最近被点击的iframe记录
          } else {
            console.log('页面非激活状态');

            if (this.activeIframe) {
              // 上报逻辑
              this.trackEvent('ad_iframe_click_leave', 'click', {
                'data-ad-slot': this.activeIframe.adSlot,
              });
              this.ttTrack(this.activeIframe.adSlot, 'click', 'ad_iframe_click_leave');

              // 在页面离开时也触发showPos方法上报广告位置
              this.vues.showPos();
            }
          }
        };

        this.iframeVisibilityTracker = onVisibilityChange;
        document.addEventListener(visibilityChangeEvent, this.iframeVisibilityTracker);
      }

      trackEvent (eventName, eventValue, dataAttributes) {
        // 事件追踪逻辑
        console.log(`${eventName} with value ${eventValue} on`, dataAttributes);

        this.vues.$eventrack(eventName, eventValue, {
          ...dataAttributes,
        });
      }
    },
    loadScriptConditionally () {
      console.log(this.adsensConfig);
      // 判断广告脚本URL是否存在
      if (!this.adsensConfig?.scriptUrl) {
        console.log('广告脚本的URL不存在,终止加载广告外链');
        this.$eventrack('no_adscript_config', 'expose');
        return;
      }
      // 检查该脚本是否已经被添加
      const existingScript = document.querySelector(`script[src="${this.adsensConfig?.scriptUrl}"]`);
      if (existingScript) {
        this.$eventrack('adscript_exist', 'expose');
        console.log('脚本已存在，无需重新添加');
        this.observeAds('ads-'); // 监听广告元素进入可视区域
        return;
      }

      console.log('准备插入脚本');
      const script = document.createElement('script');
      script.src = this.adsensConfig?.scriptUrl;
      script.crossOrigin = 'anonymous';
      script.async = true;

      const header = document.getElementsByTagName('head')[0];
      header.appendChild(script);

      this.$eventrack('adscript_add_success', 'expose');
      // script.onload = this.loadAdWithDelay.bind(this); // 使用 bind 确保 this 指向正确
      script.onload = this.observeAds.bind(this); // 使用 bind 确保 this 指向正确
      console.log('脚本插入完成,加载完成,执行加载插入广告及监听操作');

    },
    observeAds () {
      const adsElements = Object.entries(this.$refs)
        .filter(([key]) => key.startsWith('ads-'))
        .flatMap(([, ref]) => ref);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 当广告元素进入可视区域时加载广告
            console.log('Ad element is in view:', entry.target);
            this.loadAdWithDelay(entry.target);
            observer.unobserve(entry.target); // 加载后停止观察该广告元素
          }
        });
      });
      console.log(adsElements);

      adsElements.forEach(ad => {
        const adElement = ad instanceof HTMLElement ? ad : ad.$el;  // 如果是 Vue 实例，获取它的 $el
        if (adElement) {
          observer.observe(adElement); // 开始监听广告元素是否进入可视区域
          console.log('Observing ad element:', adElement);
        }
      });
    },

    loadAdWithDelay (adElement) {
      // console.log('7897988979879');
      // console.log(adElement);
      setTimeout(() => {
        this.displayAd(adElement);
      }, 1500);
    },
    async displayAd (adElement) {
      await this.$nextTick();

      if (!window.adsbygoogle || !window.adsbygoogle.loaded) {
        console.log("Adsense script not loaded yet, delaying ad display.");
        setTimeout(() => this.displayAd(adElement), 500); // 延迟再次尝试
        return;
      }

      console.log('Ad element is ready for push:', adElement);
      if (adElement.offsetWidth > 0) {
        console.log('ready to push');
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } else {
        console.log('Ad element has no size, skipping.');
      }
    },

    // 强制显示插屏广告
    forceShowInterstitialAd () {
      console.log('尝试强制显示插屏广告');
      // 确保广告脚本已加载
      if (!window.adsbygoogle || !window.adsbygoogle.loaded) {
        console.log("Adsense script not loaded yet, delaying interstitial ad display.");
        setTimeout(() => this.forceShowInterstitialAd(), 500); // 延迟再次尝试
        return;
      }

      // 查找已存在的AdSense插屏广告
      const existingInterstitial = document.querySelector('ins.adsbygoogle-noablate[data-ad-status="filled"]');

      if (existingInterstitial) {
        console.log('找到已存在的插屏广告，准备显示');

        // 保存原始样式，以便恢复
        const originalStyle = existingInterstitial.getAttribute('style');
        const originalAriaHidden = existingInterstitial.getAttribute('aria-hidden');

        // 显示插屏广告
        existingInterstitial.style.cssText = 'display: block !important;width: 100vw !important;height: 100vh !important;inset: 0px auto auto 0px !important;clear: none !important;float: none !important;margin: 0px !important;max-height: none !important;max-width: none !important;opacity: 1 !important;overflow: visible !important;padding: 0px !important;position: fixed !important;vertical-align: baseline !important;visibility: visible !important;z-index: 2147483647 !important;background: transparent !important;';
        existingInterstitial.setAttribute('aria-hidden', 'false');

        // 创建背景遮罩
        const overlay = document.createElement('div');
        overlay.className = 'interstitial-overlay';
        overlay.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 2147483646;';
        document.body.appendChild(overlay);

        // 添加关闭按钮
        const closeButton = document.createElement('div');
        closeButton.className = 'interstitial-close-btn';
        closeButton.innerHTML = '&times;';
        closeButton.style.cssText = 'position: fixed; top: 10px; right: 10px; width: 40px; height: 40px; background: rgba(0, 0, 0, 0.6); color: white; font-size: 30px; display: flex; align-items: center; justify-content: center; border-radius: 50%; cursor: pointer; z-index: 2147483648;';

        // 关闭按钮点击事件
        closeButton.addEventListener('click', () => {
          // 恢复原始状态
          if (originalStyle) {
            existingInterstitial.style.cssText = originalStyle;
          } else {
            existingInterstitial.style.display = 'none';
          }

          if (originalAriaHidden) {
            existingInterstitial.setAttribute('aria-hidden', originalAriaHidden);
          }

          // 移除遮罩和关闭按钮
          document.body.removeChild(overlay);
          document.body.removeChild(closeButton);
        });

        document.body.appendChild(closeButton);

        return true;
      } else {
        console.log('没有找到AdSense插屏广告，尝试使用备用方法');

        // 如果没有找到自动插入的广告，则使用原来的创建新元素的方法作为备用
        // 添加插屏广告容器
        const interstitialContainer = document.createElement('div');
        interstitialContainer.className = 'interstitial-ad-container';

        // 添加广告元素
        const adElement = document.createElement('ins');
        adElement.className = 'adsbygoogle';
        adElement.style.cssText = 'display:block; position:fixed; top:0; left:0; width:100%; height:100%; z-index:9999;';

        // 尝试从配置中获取广告客户端ID和广告位ID
        const adClient = this.adsensConfig && this.adsensConfig.content_1 ?
          this.adsensConfig.content_1['data-ad-client'] :
          'ca-pub-7151867298880152';

        const adSlot = this.adsensConfig && this.adsensConfig.content_1 ?
          this.adsensConfig.content_1['data-ad-slot'] :
          '1009196507';

        console.log('使用广告客户端ID:', adClient);
        console.log('使用广告位ID:', adSlot);

        adElement.setAttribute('data-ad-client', adClient);
        adElement.setAttribute('data-ad-slot', adSlot);
        adElement.setAttribute('data-ad-format', 'auto');
        adElement.setAttribute('data-full-width-responsive', 'true');

        interstitialContainer.appendChild(adElement);
        document.body.appendChild(interstitialContainer);

        // 推送广告
        console.log('推送插屏广告');
        (window.adsbygoogle = window.adsbygoogle || []).push({});

        // 添加关闭按钮 (可选)
        setTimeout(() => {
          const closeButton = document.createElement('div');
          closeButton.className = 'interstitial-close-btn';
          closeButton.innerHTML = '&times;';
          closeButton.style.cssText = 'position:fixed; top:10px; right:10px; width:40px; height:40px; background:rgba(0,0,0,0.6); color:white; font-size:30px; display:flex; align-items:center; justify-content:center; border-radius:50%; cursor:pointer; z-index:10000;';
          closeButton.addEventListener('click', () => {
            document.body.removeChild(interstitialContainer);
          });
          interstitialContainer.appendChild(closeButton);
        }, 3000);

        return false;
      }
    },
    //广告相关end

    //ciyi

    goto (name) {
      this.$router.push({ name: name });
    },

    // 显示当前屏幕可视范围内的广告坐标
    showPos () {
      console.log('执行showPos方法，显示当前可视范围内的广告坐标');

      // 获取所有广告元素
      const adElements = document.querySelectorAll('ins.adsbygoogle');
      const visibleAds = [];

      // 当前屏幕可视区域信息
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // 遍历所有广告元素，找出在可视范围内的
      adElements.forEach((adElement, index) => {
        // 使用 getBoundingClientRect 获取元素相对于视口的位置
        const rect = adElement.getBoundingClientRect();

        // 检查元素是否在视口中可见（至少部分可见）
        // rect.top 和 rect.left 是相对于视口左上角的坐标
        const isVisible = !(
          rect.bottom < 0 ||   // 元素底部在视口顶部以上
          rect.top > windowHeight ||  // 元素顶部在视口底部以下
          rect.right < 0 ||  // 元素右侧在视口左侧以外
          rect.left > windowWidth  // 元素左侧在视口右侧以外
        );

        if (isVisible) {
          // 保持与 setupIframeTracking 方法中相同的数据格式
          const transformData = {
            insX: Math.round(rect.left),
            insY: Math.round(rect.top),
            insHeight: Math.round(rect.height),
            windowWidth: windowWidth,
            windowHeight: windowHeight
          };

          visibleAds.push(transformData);
          console.log(`可视广告 #${index}:`, transformData);
        }
      });

      console.log('可视范围内的广告数量:', visibleAds.length);
      console.log('可视范围内的广告坐标:', visibleAds);

      // 即使没有可见广告，也会发送空数组
      this.$adPosition(JSON.stringify(visibleAds))
      return visibleAds;
    },

    // 计算元素在视口中的可见比例
    calculateVisibility (rect, windowWidth, windowHeight) {
      // 计算元素在视口内可见部分的面积
      const visibleWidth = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);
      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      if (visibleWidth <= 0 || visibleHeight <= 0) return 0;

      // 元素的总面积
      const totalArea = rect.width * rect.height;
      // 可见面积
      const visibleArea = visibleWidth * visibleHeight;

      // 返回百分比，四舍五入到整数
      return Math.round((visibleArea / totalArea) * 100);
    },

    // 设置插屏广告定时器
    setupInterstitialAdTimer () {
      // 检查本地存储，看上次显示广告的时间
      const lastAdTime = localStorage.getItem('lastInterstitialAdTime');
      const now = Date.now();
      const adInterval = 5 * 60 * 1000; // 5分钟间隔，可以根据需要调整

      // 如果没有记录或者已经超过了间隔时间
      if (!lastAdTime || (now - parseInt(lastAdTime)) > adInterval) {
        console.log('满足插屏广告展示条件，准备展示...');
        // 延迟3秒后显示广告，让页面有时间加载
        setTimeout(() => {
          this.forceShowInterstitialAd();
          // 记录本次显示时间
          localStorage.setItem('lastInterstitialAdTime', now.toString());
        }, 3000);
      } else {
        console.log('未达到广告展示间隔，跳过...');
        // 计算剩余等待时间
        const remainingTime = adInterval - (now - parseInt(lastAdTime));
        console.log(`距离下次广告展示还有 ${Math.floor(remainingTime / 1000)} 秒`);
      }
    },

  }
};
</script>
